import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Te levantás bien pero terminás el día con la panza explotada y el pantalón desabrochado.', 'Comés ensalada y te inflamás más que si hubieras comido una milanesa.', 'Tenés un cansancio que no se va ni durmiendo ocho horas.', 'Te dijeron que "es el estrés" o "es la edad" pero ningún tratamiento te dio una solución real.', 'Dejaste de ir a reuniones y asados por miedo a inflamarte delante de todos.', 'Gastaste fortunas en médicos y suplementos que solo te dieron alivio por unos días.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-156" data-mp="1o1oe7pfupqqi">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-157" data-mp="3idl7zp1rn8oq" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-158" data-mp="3ncxto6gwi9pq">
        <div className="max-w-4xl mx-auto" data-id="element-159" data-mp="3nabo2cdkm4a5">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-160" data-mp="1yzvl3o3bazx3">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[24px]" data-id="element-161" data-mp="23sokdwg0hg1s">
              ¿Cuánto tiempo más vas a esperar para volver a sentirte liviana?
            </h2>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-162" data-mp="1b3rg4x8mxjs1">
              Sos una mujer que se cuida. Comés ordenado, buscás información y
              tomás en serio tu salud.
            </p>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-163" data-mp="1k2cvkjit8iol">
              Pero hasta ahora, nadie te había dado la hoja de ruta correcta
              para tu cuerpo después de los 55.
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-164" data-mp="2vhje3qz8zx6e">
              No es falta de voluntad. Es que te faltaba el sistema correcto.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-165" data-mp="1y3qak706lfke">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-166" data-mp="225bnfscpttul" data-mpi={index}>
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-167" data-mp="1o7d7iiiqxpcz" />
                <p className="text-lg text-gray-200" data-id="element-168" data-mp="qpwowk4uytxd">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-169" data-mp="vny7l3ydgr8b">
            <h3 className="text-2xl md:text-4xl font-bold text-brand-gold italic font-[Inter,_sans-serif]" data-id="element-170" data-mp="e9x085sdg3ny">
              ¿Y si pudieras dejar de sentirte así a partir de hoy mismo?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}